import stripHtmlTags from './ConversationsList/Conversation/stripHtmlTags';

// A "fast pitch" arrived suspiciously soon after the request went up — sometimes a tell
// for AI-generated text, so the inbox marks it (badge on the row, banner in the pane).
// Mirrors PitchCard's Table-view threshold. A pitch with no text (video recorded on Qwoted)
// can't be AI-written, so it is never "fast".
export const FAST_PITCH_MS = 15 * 60 * 1000;

export const isFastPitch = (sentAt, requestCreatedAt, pitchText) => Boolean(sentAt && requestCreatedAt)
  && stripHtmlTags(pitchText || '').trim().length > 0
  && new Date(sentAt) - new Date(requestCreatedAt) < FAST_PITCH_MS;
